import { Box, Button, ButtonProps, CircularProgress } from '@mui/material';
import React, { PropsWithChildren, ReactElement } from 'react';

export function LoaderButton({
  loading,
  disabled,
  children,
  ...props
}: PropsWithChildren<
  ButtonProps & {
    loading?: boolean;
    disabled?: boolean;
  }
>): ReactElement {
  return (
    <Button {...props} disabled={disabled || loading}>
      {loading && (
        <Box
          style={{
            position: 'absolute',
            top: 'calc(50% - 10px)',
            left: 'calc(50% - 10px)',
          }}
        >
          <CircularProgress
            color={disabled ? 'inherit' : 'primary'}
            size={20}
          />
        </Box>
      )}
      {children}
    </Button>
  );
}
